<template>
    <div class="news" id="news">
        <div class="mobiletopbox hidden-sm-and-up">
            <div class="mobiletopbox_top">
                <div class="navigation">
                    <div class="navigation_location"></div>
                    <div class="navigation_index" @click="goIndex">首页</div>
                    <div class="navigation_img"></div>
                    <div class="navigation_text">{{currentRouterTitle}}</div>
                    <div class="navigation_img"></div>
                    <div class="navigation_text">详情</div>
                </div>
            </div>
        </div>
        <div class="news_box section">
            <div class="news_right" v-loading="loading">
                <div class="news_right_top hidden-xs-only">
                    <div class="navigation">
                        <div class="navigation_location"></div>
                        <div class="navigation_text">当前所在位置：</div>
                        <div class="navigation_index" @click="goIndex">首页</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">{{currentRouterTitle}}</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">详情</div>
                    </div>
                </div>
                <div class="news_right_bottom">
                    <div class="news_right_bottom_box">
                        <div class="details_content">
                            <div class="details_title">
                                <div class="details_title_top">{{ detailsContent.title }}</div>
                                <div class="details_title_bottom">
                                    <div class="details_title_bottom_left">
                                        发布时间：
                                        <span>{{detailsContent.publishTime?handleTime(detailsContent.publishTime):""}}</span>
                                    </div>
                                    <div class="details_title_bottom_line"></div>
                                    <div class="details_title_bottom_right">
                                        浏览量：{{detailsContent.browseCount?detailsContent.browseCount:0}}
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                            <div class="common_artical" v-if="detailsContent.content">
                                <div v-html="detailsContent.content"></div>
                            </div>
                            <div class="file" v-if="detailsContent.newsFileList && detailsContent.newsFileList.length > 0">
                                <div class="file_box">
                                    <div class="file_left">附加文件：</div>
                                    <div class="file_right">
                                        <div class="file_right_item" v-for="(item, i) in detailsContent.newsFileList" :key="i">
                                            <a :href="baseUrl + item.fileUrl">{{ item.fileName }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="details_content_other">
                            <div class="details_content_other_item">
                                上一篇：
                                <span v-if="prevDetail&&prevDetail.title" @click="handlePrev(prevDetail)">{{prevDetail.title}}</span>
                            </div>
                            <div class="details_content_other_middle" @click="goBack">
                                <div class="details_content_other_right_img">
                                    <img src="../assets/images/common/back_list.png" alt="">
                                </div>
                                <div class="details_content_other_right_text">返回列表</div>
                            </div>
                            <div class="details_content_other_item">
                                下一篇：
                                <span v-if="nextDetail&&nextDetail.title" @click="handlePrev(nextDetail)">{{nextDetail.title}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { newsList,newsDetails,newsBrowse } from '../untils/common-api.js'
export default {
    data() {
        return {
            name:this.$route.params.name,
            baseUrl: process.env.VUE_APP_BASE_URL,
            loading: false,
            index:this.$route.params.type,
            id: this.$route.params.id,
            current:this.$route.params.current,
            query: {
                current: 1,
                pageSize: -1,
                model:null,
                newsType: this.$route.params.type?this.$route.params.type:'',
                lang:1,
            },
            newsList: [],
            detailsContent: '',
            prevDetail:{},
            nextDetail:{},

        }
    },
    computed: {
        'currentRouterTitle':function() {
            let title=''
            if(this.$route.params.name == 'certification') {
                title = '标准认证'
                this.query.model = 6
            } else if(this.$route.params.name == 'work') {
                title = '党建工作'
                this.query.model = 3
            } else if(this.$route.params.name == 'brand') {
                title = '品牌活动'
                this.query.model = 4
            } else if(this.$route.params.name == 'books') {
                title = '联盟出版书籍'
                this.query.model = 5
            }
            return title
        }
    },
    created() {
        this.getNewsList()
        this.getDetails(this.id)
    },
    mounted() {
        this.getScrollTop()
    },
    methods:{
        /**
         * /specifics/:name/:type/:id
         * /:name 指定列表路径
         * /:type 指定列表类型，获取列表名称
         * /:id   指定文章id
         */
        // 获取新闻列表
        async getNewsList() {
            let res = await newsList(this.query)
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            this.newsList = res.data.records
            this.getOtherDetail()
        },
        getOtherDetail() {
            if(this.newsList.length>0) {
                // 通过id在列表中查找当前文章的索引
                let index = this.newsList.findIndex(item => item.id == this.id)
                // 如果索引为0，说明当前文章为第一篇，没有上一篇
                if (index == 0) {
                    this.prevDetail = {}
                } else {
                    this.prevDetail = this.newsList[index - 1]
                }
                // 如果索引为列表长度减1，说明当前文章为最后一篇，没有下一篇
                if (index == this.newsList.length - 1) {
                    this.nextDetail = {}
                } else {
                    this.nextDetail = this.newsList[index + 1]
                }
            }
        },
        handlePrev(item) {
            this.id = item.id
            this.getDetails(item.id)
            this.getOtherDetail()
            this.getScroll()
        },
        async getDetails(id) {
            this.loading = true // loading start
            let res = await newsDetails(id)
            this.loading = false // loading end
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            this.detailsContent = res.data
            this.getNewsBrowse(id)
        },
        async getNewsBrowse(id) {
            const res = await newsBrowse(id)
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
        },
        handleTime(time) {
            if(time) {
                let year = time.substring(0,4);
                let month = time.substring(5,7);
                let day = time.substring(8,10);
                let timeStr = year+'-'+month+'-'+day
                return timeStr;
            }
        },
        getScroll() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 600)
                }, 500);
            }
        },
        getScrollTop() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 0)
                }, 0);
            }
        },
        goIndex() {
            this.$router.push('/index')
        },
        goBack() {
            const scrollPosition = window.sessionStorage.getItem('scrollPosition');
            if (scrollPosition == '-1') {
                window.sessionStorage.setItem('scrollPosition', 0);
            }
            // window.location.href = '/#/news?type=' + this.index + '&current='+this.current
            this.$router.push('/'+this.$route.params.name+'?type=' + this.index + '&current='+this.current)
        }
    },
    beforeRouteLeave(to, from, next) {
        if(this.name != to.name) {
            window.sessionStorage.removeItem('scrollPosition'); 
        }
        next();
    },
}
</script>
<style lang="less" scoped>
.news {
    background-color: #f6f9ff;
    padding: 30px 0 80px 0;
    .news_box {
        .news_right {
            width: calc(100%);
            .news_right_top {
                margin-bottom: 20px;
            }
            .news_right_bottom {
                background-color: #ffffff;
                .news_right_bottom_box {
                    padding: 30px;
                    .details_content {
                        .details_title {
                            padding-bottom: 25px;
                            border-bottom: 1px dashed #DCDCDC;
                            .details_title_top {
                                font-size: 24px;
                                line-height: 36px;
                                font-weight: bold;
                                text-align: center;
                                margin-bottom: 20px;
                            }
                            .details_title_bottom {
                                font-size: 16px;
                                color: #787878;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                .details_title_bottom_left {
                                    span {
                                        color: #000000;
                                    }
                                }
                                .details_title_bottom_line {
                                    width: 1px;
                                    height: 15px;
                                    background-color: #000000;
                                    margin: 0 20px;
                                }
                                .details_title_bottom_right {
                                    span {
                                        color: #000000;
                                    }
                                }
                            }
                        }
                        .common_artical {
                            padding: 25px 0;
                            border-bottom: 1px dashed #DCDCDC;
                        }
                        .file {
                            padding: 25px 0;
                            border-bottom: 1px dashed #DCDCDC;
                            .file_box {
                                display: flex;
                                .file_left {
                                    width: 80px;
                                    font-size: 16px;
                                }
                                .file_right {
                                    width: calc(100% - 80px);
                                    .file_right_item {
                                        margin-bottom: 5px;
                                        a {
                                            font-size: 16px;
                                        }
                                    }
                                    .file_right_item:last-child {
                                        margin-bottom: 0;
                                    }
                                }
                            }
                        }
                    }
                    .details_content_other {
                        margin-top: 30px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .details_content_other_item {
                            width: calc((100% - 118px - 82px)/2);
                            font-size: 16px;
                            color: #4B4B4B;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            span {
                                cursor: pointer;
                            }
                        }
                        .details_content_other_middle {
                            width: 118px;
                            height: 72px;
                            background: #2277ec;
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                            align-items: center;
                            border-radius: 36px;
                            cursor: pointer;
                            .details_content_other_right_img {
                                img {
                                    width: 35px;
                                    height: 35px;
                                }
                            }
                            .details_content_other_right_text {
                                font-size: 16px;
                                color: #ffffff;
                            }
                        }
                    }
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .news {
        padding: 0.3rem 0 0.6rem 0;
        .news_box {
            .news_right {
                padding-top: .2rem;
                .news_right_bottom {
                    .news_right_bottom_box {
                        padding: 0.3rem 0.2rem;
                        .details_content {
                            .details_title {
                                padding-bottom: 0.3rem;
                                .details_title_top {
                                    font-size: 0.35rem;
                                    line-height: 1.5;
                                    margin-bottom: .2rem;
                                }
                                .details_title_bottom {
                                    font-size: 0.26rem;
                                    .details_title_bottom_line {
                                        width: 0.02rem;
                                        height: 0.28rem;
                                        margin: 0 0.2rem;
                                    }
                                }
                            }
                            .common_artical {
                                padding: 0.3rem 0;
                            }
                            .file {
                                padding: 0.3rem 0;
                                .file_box {
                                    .file_left {
                                        width: 1.4rem;
                                        font-size: 0.28rem;
                                    }
                                    .file_right {
                                        width: calc(100% - 1.4rem);
                                        .file_right_item {
                                            margin-bottom: 0.1rem;
                                            a {
                                                font-size: 0.28rem;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .details_content_other {
                            margin-top: .3rem;
                            .details_content_other_item {
                                width: calc((100% - 1.7rem - 0.2rem)/2);
                                font-size: 0.28rem;
                            }
                            .details_content_other_middle {
                                width: 1.7rem;
                                height: 1.1rem;
                                border-radius: 0.55rem;
                                .details_content_other_right_img {
                                    img {
                                        width: 0.5rem;
                                        height: 0.5rem;
                                    }
                                }
                                .details_content_other_right_text {
                                    font-size: 0.26rem;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

}
</style>